import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "corp" }

import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import PageModal from '@/components/PageModal.vue'
import { usePageModal } from '@/hooks/usePageModal'


export default /*#__PURE__*/_defineComponent({
  __name: 'Corp',
  setup(__props) {

const [pageModalRef, defaultInfo, handleNewData, handleEditData] =
  usePageModal()

return (_ctx: any,_cache: any) => {
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageContent, {
      ref: "pageContentRef",
      contentTableConfig: _unref(contentTableConfig),
      pageName: "enterpriseWechat/config",
      onEditBtnClick: _unref(handleEditData)
    }, null, 8, ["contentTableConfig", "onEditBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      "modal-config": _unref(modalConfig),
      defaultInfo: _unref(defaultInfo),
      title: "编辑",
      validOtherInfo: () => true,
      pageName: "enterpriseWechat/config"
    }, null, 8, ["modal-config", "defaultInfo"])
  ]))
}
}

})